import React, { useCallback, useEffect, useState } from "react";
import {
  Typography,
  Container,
  Button,
  CircularProgress,
  Modal,
  Stack,
  Grid,
  IconButton,
  Drawer,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import {
  DragIndicator as DragIndicatorIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

import { makeStyles } from "@mui/styles";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { backend, API_URL } from "../../../config";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const StorefrontBanners = (props) => {
  const classes = useStyles();

  const bannerDataInitialState = {
    id: null,
    image_url: "",
    link_url: "",
    display_order: 0,
    active: true,
  };

  const [storefrontBanners, setStorefrontBanners] = useState([]);
  const [storefrontBannersLoaded, setStorefrontBannersLoaded] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [confirmModal, setConfirmModal] = useState(false);
  const [drawerStatus, setDrawerStatus] = useState(false);
  const [bannerData, setBannerData] = useState(bannerDataInitialState);

  const toggleDrawer = (banner = null) => {
    if (banner !== null) {
      setBannerData(banner);
    } else {
      setBannerData(bannerDataInitialState);
    }

    setDrawerStatus(!drawerStatus);
  };

  const handleChange = (e, v) => {
    const { checked, name, value } = e.target;

    console.log(e, v);

    setBannerData((prevState) => {
      let bannerObj = { ...prevState };

      if (["active"].includes(name)) {
        bannerObj = { ...bannerObj, [name]: checked };
      } else {
        bannerObj = { ...bannerObj, [name]: value };
      }

      return bannerObj;
    });
  };

  const sendBannerRequest = async () => {
    const bannerPayload = { ...bannerData };

    if (bannerPayload.id === null) {
      delete bannerPayload.id;

      await backend
        .post(`${API_URL}storefrontbanners/`, bannerPayload)
        .then(({ data }) => {
          setStorefrontBanners((prevState) => [...prevState, data]);
          toggleDrawer();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      await backend
        .patch(`${API_URL}storefrontbanners/${bannerPayload.id}`, bannerPayload)
        .then(({ data }) => {
          const updatedBanners = storefrontBanners.map((banner) =>
            banner.id === data.id ? data : banner,
          );
          setStorefrontBanners(updatedBanners);
          toggleDrawer();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const crudDrawerContent = (
    <div style={{ width: 400, padding: 16 }}>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <Typography component="h4">
            <b>
              {`${bannerData?.id ? "Edit" : "Add"} Banner: ${bannerData.id || ""}`}
            </b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            required={true}
            id="outlined-basic"
            variant="outlined"
            label="Image URL"
            name="image_url"
            value={bannerData?.image_url || ""}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            required={true}
            id="outlined-basic"
            variant="outlined"
            label="Link URL"
            name="link_url"
            value={bannerData?.link_url || ""}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            type="number"
            size="small"
            required={true}
            id="outlined-basic"
            variant="outlined"
            label="Display Order"
            name="display_order"
            value={
              bannerData.display_order === null ? 99 : bannerData.display_order
            }
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControlLabel
            value="start"
            control={
              <Checkbox
                name="active"
                value={bannerData?.active || false}
                checked={bannerData?.active || false}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Active"
            labelPlacement="end"
          />
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" spacing={1} justifyContent="right">
            <Button onClick={toggleDrawer}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendBannerRequest()}
            >
              Save
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to save the storefront banners arrangement?
          <br />
          <br />
          <div align="right">
            <Button onClick={() => toggleConfirmModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving storefront banners arrangement <br />
              This may take some time relative to the number of banners
              configured
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the banners arrangement
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Banners have been successfully saved
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const reorderArray = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const orderListCatReorder = reorderArray(
      storefrontBanners,
      result.source.index,
      result.destination.index,
    );

    setStorefrontBanners(orderListCatReorder);
  };

  const onDelete = (bannerId) => {
    const bannersFiltered = storefrontBanners.filter(
      (banner) => banner.id !== bannerId,
    );

    setStorefrontBanners(bannersFiltered);
  };

  const handleBack = () => {
    props.history.push("/storefront");
  };

  const resolveRequest = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);

    toggleConfirmModal();
  };

  const resolveError = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);
    setErrorInfo({ error: false, message: "" });
    toggleConfirmModal();
  };

  const sendRequest = () => {
    setLoadingFlag(true);

    Promise.all(
      storefrontBanners.map(async (item, index) => {
        const bannerPayload = { ...item, display_order: index };

        return await backend
          .patch(
            `${API_URL}storefrontbanners/${bannerPayload.id}`,
            bannerPayload,
          )
          .then(({ data }) => {
            return data;
          })
          .catch((error) => {
            console.log(error);
            setErrorInfo({
              error: true,
              message: JSON.stringify(error.response.data),
            });
          });
      }),
    ).then((result) => {
      console.log(result);

      if (!errorInfo.error) {
        setFinishedFlag(true);
        setLoadingFlag(false);
      }
    });
  };

  const getStorefrontBanners = useCallback(async () => {
    await backend
      .get(`${API_URL}storefrontbanners?no_page=1`)
      .then(({ data }) => {
        const dataMap = data.sort((a, b) => a.display_order - b.display_order);

        setStorefrontBanners(dataMap);
        setStorefrontBannersLoaded(true);
      })
      .catch((error) => {
        setErrorInfo({ error: true, message: error.message });
        setStorefrontBannersLoaded(true);
      });
  }, []);

  useEffect(() => {
    if (!storefrontBannersLoaded) {
      getStorefrontBanners();
    }
  }, [storefrontBannersLoaded, getStorefrontBanners]);

  return (
    <>
      <Container>
        <Modal open={confirmModal} onClose={toggleConfirmModal}>
          {confirmModalContent}
        </Modal>
        <Drawer anchor="right" open={drawerStatus} onClose={toggleDrawer}>
          {crudDrawerContent}
        </Drawer>
        <Typography component="h6" variant="h6" align="center">
          Storefront Banners
        </Typography>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignContent="center"
          sx={{ marginTop: 2 }}
        >
          <Grid item xs={12}>
            <Stack direction="row" spacing={1} justifyContent="right">
              <Button
                variant="contained"
                color="primary"
                onClick={() => toggleDrawer()}
              >
                Add Block
              </Button>
            </Stack>
          </Grid>
          {storefrontBanners.length > 0 && (
            <Grid item xs={12} sm={12}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId={`storefront-banners-droppable`}>
                  {(provided) => (
                    <Grid
                      container
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {storefrontBanners.map((banner, index) => (
                        <Draggable
                          key={`storefront-banner-${banner.id}`}
                          draggableId={`storefront-banner-${banner.id}`}
                          index={index}
                        >
                          {(provided) => (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                "&:hover": { backgroundColor: "#eee" },
                              }}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <Grid container spacing={0} alignItems="center">
                                <Grid item xs={"auto"}>
                                  <IconButton aria-label="drag">
                                    <DragIndicatorIcon />
                                  </IconButton>
                                </Grid>
                                <Grid item xs={true}>
                                  {`${banner.id}`}
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <Stack direction="row" spacing={1}>
                                    <IconButton
                                      aria-label="edit"
                                      onClick={() => toggleDrawer(banner)}
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() => onDelete(banner.id)}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </Stack>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Grid>
                  )}
                </Droppable>
              </DragDropContext>
            </Grid>
          )}
        </Grid>
        <br />
        {!storefrontBannersLoaded && (
          <div align="center">
            <br />
            <CircularProgress />
            <div>
              Loading information... <br />
            </div>
          </div>
        )}
        {storefrontBanners.length === 0 && storefrontBannersLoaded && (
          <div align="center">There are no storefront banners configured.</div>
        )}
        {storefrontBanners.length > 0 && (
          <Stack direction="row" spacing={1} justifyContent="right">
            <Button onClick={handleBack}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => toggleConfirmModal()}
            >
              Save Arrangement
            </Button>
          </Stack>
        )}
      </Container>
    </>
  );
};

export default StorefrontBanners;
